<template lang="pug">
	div
		//
			menu-superior(:menu="menu")
		router-view

</template>

<script>
export default {
	data () {
		return {
			menu: [
				{
					url: '/main/organizar-emisoras/opcion-a',
					nombre: 'Opcion A',
					icono: 'fa fa-cube'
				},
				{
					url: '/main/organizar-emisoras/opcion-b',
					nombre: 'Opcion B',
					icono: 'fa fa-cube'
				}
			]
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/organizar-emisoras/vue/App.vue